import { Injectable, inject } from '@angular/core';
import {
  Event,
  NavigationStart,
  Router,
} from '@angular/router';
import {
  SwUpdate,
  VersionReadyEvent,
} from '@angular/service-worker';
import {
  Subject,
  filter,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PwaUpdateNotificationService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly router = inject(Router);

  isCancelled = false;

  readonly showUpdateMessage = new Subject<boolean>();

  constructor() {
    // If user cancels update,
    // force refresh on next route change
    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationStart =>
            event instanceof NavigationStart
        )
      )
      .subscribe(() => {
        if (this.isCancelled) {
          this.isCancelled = false;
          window.location.reload();
        }
      });
  }

  initWatcher(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent =>
            event.type === 'VERSION_READY'
        )
      )
      .subscribe(() => {
        this.showUpdateMessage.next(true);
      });
  }

  cancelUpdate(): void {
    this.showUpdateMessage.next(false);
    this.isCancelled = true;
  }
}